import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@trader-dashboard/shared';
import { LoadingView } from './Loaders';

export const PrivateRoute = () => {
  const { loaded: authLoaded, authenticated, checkAuthStatus } = useAuth();
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      await checkAuthStatus();
      setIsAuthChecked(true);
    };
    
    checkAuth();
  }, [checkAuthStatus]);

  if (!authLoaded || !isAuthChecked) {
    return <LoadingView />
  }
  
  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export const AdminRoute = () => {
  const { loaded: authLoaded, authenticated, checkAuthStatus, isRootAdmin } = useAuth();
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      await checkAuthStatus();
      setIsAuthChecked(true);
    };
    
    checkAuth();
  }, [checkAuthStatus]);

  if (!authLoaded || !isAuthChecked) {
    return <LoadingView />
  }
  
  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isRootAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};